import { QueryClientProvider } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { Suspense, useState } from "react";
import { RouterProvider } from "react-router";

import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ThemeProvider } from "@/components/ThemeProvider";
import { Toaster } from "@/components/ui/sonner";
import { createQueryClient } from "@/lib/queryClient";
import { useIsMobile } from "@/lib/useMediaQuery";
import { BootGate } from "@/routes/BootGate";
import { router } from "@/routes";

function RouteFallback() {
  return (
    <div className="flex min-h-dvh items-center justify-center" aria-busy="true">
      <Loader2 className="text-muted-foreground size-6 animate-spin" aria-label="Carregando" />
    </div>
  );
}

export default function App() {
  // Created in state so the client survives re-renders but is still per-app
  // rather than a module global, which keeps tests isolated.
  const [queryClient] = useState(createQueryClient);

  /* Top right is under the account menu on a phone, and the toasts carry the
     server's own sentences -- the ones that explain why a cortesia was
     refused. Centred, they clear the header instead of covering it. */
  const isMobile = useIsMobile();

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <BootGate>
            <Suspense fallback={<RouteFallback />}>
              <RouterProvider router={router} />
            </Suspense>
          </BootGate>
          <Toaster richColors position={isMobile ? "top-center" : "top-right"} />
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
